export default __webpack_public_path__ + "static/media/Nestle.16955db7.png";